import axios from '../api';
import { IContactForm } from '../types/contactForm.types';

export const submitContactForm = async (values: IContactForm) => {
  try {
    const response = await axios.post('/api/contact', {
      name: values.name,
      email: values.email,
      subject: values.subject,
      message: values.message,
      recaptcha_token: values.recaptchaToken,
    });
    if (response.status >= 200 && response.status < 300) {
      return 'success';
    }
    return null;
  } catch (error) {
    return null;
  }
};
